import React, { useEffect } from "react";
import "./BcModal.css";

interface BcModalProps {
  open: boolean;
  onClose: () => void;
  kicker?: string;
  title: string;
  text?: string;
  ctaLabel?: string;
  ctaUrl?: string;
  onCta?: () => void;
  secondaryLabel?: string;
  image?: string;
  icon?: React.ReactNode;
}

const BcModal: React.FC<BcModalProps> = ({
  open,
  onClose,
  kicker,
  title,
  text,
  ctaLabel,
  ctaUrl,
  onCta,
  secondaryLabel,
  image,
  icon,
}) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  const external = !!ctaUrl && /^https?:\/\//i.test(ctaUrl);

  return (
    <div className="bcm-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="bcm-card" role="dialog" aria-modal="true" aria-label={title}>
        <button className="bcm-close" onClick={onClose} aria-label="Fechar">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" /></svg>
        </button>
        {image ? <div className="bcm-media" style={{ backgroundImage: `url("${image}")` }} /> : null}
        <div className="bcm-body">
          {icon && !image ? <div className="bcm-icon">{icon}</div> : null}
          {kicker ? <span className="bcm-kicker">{kicker}</span> : null}
          <h2 className="bcm-title">{title}</h2>
          {text ? <p className="bcm-text">{text}</p> : null}
          <div className="bcm-actions">
            {ctaLabel ? (
              ctaUrl ? (
                <a
                  className="bcm-cta"
                  href={ctaUrl}
                  target={external ? "_blank" : undefined}
                  rel={external ? "noreferrer" : undefined}
                  onClick={onClose}
                >
                  {ctaLabel}
                </a>
              ) : (
                <button className="bcm-cta" onClick={onCta || onClose}>{ctaLabel}</button>
              )
            ) : null}
            {secondaryLabel ? (
              <button className="bcm-secondary" onClick={onClose}>{secondaryLabel}</button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BcModal;
